import React from 'react'
import {Modal} from 'react-bootstrap'
import {KTIcon} from '../../helpers'

interface OfflineModalProps {
  show: boolean
}

const OfflineModal: React.FC<OfflineModalProps> = ({show}) => {
  const isDevelopment = false

  const simulateOffline = () => {
    if (isDevelopment) {
      // Temporarily override navigator.onLine for testing
      Object.defineProperty(navigator, 'onLine', {
        writable: true,
        value: false,
      })

      // Dispatch offline event to trigger the hook
      window.dispatchEvent(new Event('offline'))

      // Reset after 10 seconds
      setTimeout(() => {
        Object.defineProperty(navigator, 'onLine', {
          writable: true,
          value: true,
        })
        window.dispatchEvent(new Event('online'))
      }, 10000)
    }
  }

  return (
    <>
      <Modal
        show={show}
        backdrop='static'
        keyboard={false}
        centered
        className='offline-modal'
        data-testid='offline-modal'
      >
        <div className='modal-content border-0 rounded-3'>
          <div className='modal-body text-center p-9'>
            {/* Icon */}
            <div className='mb-5'>
              <div className='d-flex justify-content-center'>
                <div className='symbol symbol-100px symbol-circle bg-light-warning d-flex align-items-center justify-content-center'>
                  <KTIcon iconName='disconnect' className='fs-2x text-warning' />
                </div>
              </div>
            </div>

            {/* Title */}
            <h2 className='mb-4 text-gray-800 fw-bold'>Connection Lost</h2>

            {/* Description */}
            <div className='text-gray-600 fs-6 mb-6'>
              <p className='mb-3'>Your internet connectivity is currently offline.</p>
              <p className='mb-0'>
                Please check your connection and try again. This modal will automatically close when
                your connection is restored.
              </p>
            </div>

            {/* Status indicator */}
            <div className='d-flex align-items-center justify-content-center'>
              <div className='spinner-border spinner-border-sm text-warning me-3' role='status'>
                <span className='visually-hidden'>Checking connection...</span>
              </div>
              <span className='text-muted fs-7'>Waiting for connection...</span>
            </div>
          </div>
        </div>
      </Modal>

      {/* Global overlay to prevent interactions when offline */}
      {show && (
        <div
          className='offline-overlay'
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            zIndex: 1040,
            pointerEvents: 'auto',
          }}
        />
      )}

      {/* Development Test Button - only visible in development */}
      {isDevelopment && !show && (
        <div
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: 9999,
          }}
        >
          <button
            onClick={simulateOffline}
            className='btn btn-warning btn-sm'
            title='Test Offline Mode (Dev Only)'
          >
            <KTIcon iconName='disconnect' className='fs-3' />
            Test Offline
          </button>
        </div>
      )}
    </>
  )
}

export {OfflineModal}
